import CryptoJS from "crypto-js";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useCookies } from "react-cookie";
import { Helmet } from "react-helmet";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faQuestion } from '@fortawesome/free-solid-svg-icons';
// import { faHouse } from '@fortawesome/free-solid-svg-icons';
// import { faCoffee } from '@fortawesome/free-solid-svg-icons'
// import { faWhatsapp } from '@fortawesome/free-solid-svg-icons';
import Sheet from "react-modal-sheet";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Compare from "../../assets/images/Compare.png";
import DelIcon from "../../assets/images/delIcon.svg";
import Easy from "../../assets/images/Easy.png";
import home from "../../assets/images/home.svg";
import patientImage from "../../assets/images/Mask Group2.png";
import MobPath from "../../assets/images/MobPath.png";
import MobRadio from "../../assets/images/MobRadio.png";
import ficon from "../../assets/images/popularS.svg";
import Wall from "../../assets/images/Wall.png";
import yellowcard from "../../assets/images/yellowcard.svg";
import {
  BioCheck,
  CardSelectTest,
  MobileCardSelectedTest,
  Popup,
  Questions,
  SliderComponent,
} from "../../components";
import Layout from "../../layout";
import {
  clearTest,
  featureRemoveTest,
  getAreas,
  getCities,
  login,
  removeTest,
  testValue,
  getPartners,
} from "../../redux/auth/actions";
import axios from "../../redux/axios";
import { getLabPackages } from "../../redux/labpackage/labpackageActions";
import { api, passcodeKey, tokenKey, usernameKey } from "../../utils/constants";
import LabPackage from "../Lab-Packages/LabPackage";
import "./Landing.scss";
import "./landingMob.scss";
import PartnerSlider from "./PartnerSlider";
import useWindowSize from "../../hooks/useWindowSize";
import SliderComponent2 from "./slide";
import { getFirebaseAnalyticsInstance } from "../../firebase";
import ReactGA from 'react-ga';
import { Button } from "bootstrap";
import blueimage from "../../assets/images/blueimage.png";
import mobblueimage from "../../assets/images/mob-blueimage.png";

function BuyTest() {
  const history = useHistory();
  const [btn, setBtn] = useState(false);
  const [addedItems, setAddedItems] = useState([]);
  const [showSelected, setShowSelected] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [filterValue, setFilterValue] = useState("pathology");
  const [locationPOP, showLocationPop] = useState(false);
  const [alertlocationPOP, showalertLocationPop] = useState(false);
  const [width, height] = useWindowSize();
  const [topDeals, setTopDeals] = useState();
  const [bioCheck, setBioCheck] = useState();
  const [partner, setPartner] = useState([]);
  const [mobileView, setMobileView] = useState(false);
  const [cookies, setCookie] = useCookies([usernameKey, passcodeKey, tokenKey]);

  // const [BtnActive,setBtnActive] = useState('Patho_logy')

  const [selectedButton, setSelectedButton] = useState(null);

  const handleButtonSelect = (buttonName) => {
    setSelectedButton(buttonName);
  };

  const [showPopup, setShowPopup] = useState(false);

  const handleButtonClick = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const cities = []; //useSelector((state) => state.auth.cities);

  const selected_test = useSelector(
    (state) => state.selected_test.selected_test
  );

  const user = useSelector((state) => state.auth);

  const [landingSearch, selandingSearch] = useState("");
  const [landData, setLandData] = useState({});
  console.log(landData, "landing")
  const test = useSelector((state) => state);
  const dispatch = useDispatch();
  const arealocal = useSelector((state) => state.area);

  useEffect(() => {
    dispatch(getLabPackages(0, '', 'all', 8));
    dispatch(getCities());
    dispatch(getAreas());
    dispatch(getPartners());
  }, [dispatch]);

  const fetchUserDetails = () => {
    if (cookies.passcode && cookies.username) {
      let username = CryptoJS.AES.decrypt(
        cookies.username,
        process.env.REACT_APP_SECRET_KEY
      ).toString(CryptoJS.enc.Utf8);
      let password = CryptoJS.AES.decrypt(
        cookies.passcode,
        process.env.REACT_APP_SECRET_KEY
      ).toString(CryptoJS.enc.Utf8);
      dispatch(login({ username: username, password }));
    }
  };
  console.log(partner, "partner");
  useEffect(() => {
    fetchUserDetails();
  }, [cookies.username]);

  const getLoginDetails = () => {
    let userName = user.username;
    let password = " ";
    if (localStorage.getItem("PASSCODE") !== null || undefined) {
      password = localStorage.getItem("PASSCODE");
    } else if (localStorage.getItem("PWD") !== null || undefined) {
      password = localStorage.getItem("PWD");
    }
    // let password = localStorage.getItem("PWD");
    // console.log(localStorage.PASSCODE, "password")
    let data = password + userName;
    let encrypted = CryptoJS.AES.encrypt(data, "doctall");
    return encrypted.toString().replaceAll("/", "DMP");
  };

  const handlePopupClose = () => {
    dispatch(clearTest());
    showLocationPop(false);
  };
  const handlealertPopupClose = () => {
    dispatch(clearTest());
    showalertLocationPop(false);
  };
  const handlePopupOpen = () => {
    // dispatch(clearTest());
    showLocationPop(true);
    showalertLocationPop(false);
  };
  useEffect(() => {
    if (selected_test && selected_test.length !== 0) {
      let res = [];
      let recommended_test_uuid = [];
      let patientName = "";
      let patientId = "";
      let partner_uuid = "";

      selected_test.map((v, i) => {
        console.log(v, "sxcasvcgjh")
        v && v.doc && v.doc.testname_uuid && v.doc.testname_uuid !== undefined
          ? res.push({
            test_type:
              v.doc.testname_uuid.slice(0, 2) === "LP"
                ? "pathology"
                : v.doc.testname_uuid.slice(0, 2) === "LR"
                  ? "radiology"
                  : v.doc.testname_uuid === undefined
                    ? "biochecks"
                    : "nodata",
            testname_uuid: v.doc.testname_uuid,
            testName: v.doc.standardisedtestname,
            areaRef: arealocal && arealocal.area && arealocal.area.value,
            partner_uuid: v?.doc?.partner_uuid
          })
          : res.push({
            test_type: "biochecks",
            uuid: v.doc.uuid,
          });

        if (v.patient_uuid) {
          recommended_test_uuid.push(v.doc.testname_uuid);
          patientName = v.patient_name;
          patientId = v.patient_uuid;
        }
      });

      setLandData({
        data: res,
        homeservice: "yes",
        partner_uuid: partner_uuid,
        recommended_test: {
          test_uuid: recommended_test_uuid,
          patient_name: patientName,
          patient_uuid: patientId,
        },
      });
    }
  }, [selected_test]);

  useEffect(() => {
    let cartData = JSON.parse(localStorage.getItem("cartItem"));

    if (cartData) {
      cartData.items.map((i) => (i.user_uuid = test.auth.uuid));
      cartData.user_uuid = test.auth.uuid;
      var config = {
        method: "post",
        url: api.compareprice_post,
        headers: {
          "Content-Type": "application/json",
        },
        data: cartData,
      };
      axios(config)
        .then(function (response) {
          if (response.data.status === "Success") {
            localStorage.removeItem("cartItem");
            history.push({ pathname: "/cart-update" });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, []);

  const addFireBaseAnalytics = async () => {
    try {
      await getFirebaseAnalyticsInstance().logEvent("USER_LOGIN", {
        eventType: "LOGIN",
        platform: "web",
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // setFilterData([])
    setFilterData([]);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/labtest/diagnostic/searchLists?value=${landingSearch}`
      )
      .then((res) => {
        // setFilterData(res.data.data)
        setFilterData(res.data.data);
        // getFirebaseAnalyticsInstance().logEvent('Lab test searched', landingSearch)
        ReactGA.event({
          category: 'Lab test searched',
          action: landingSearch,
          label: 'Lab test searched',
        })
      })
      .catch((err) => console.log(err));
  }, [filterValue, landingSearch]);

  const handleItems = (id, val) => {
    if (arealocal.area.value === "") {
      // showLocationPop(true);
      showalertLocationPop(true);
    } else {
      const idToRemove = id;
      if (addedItems.includes(val)) {
        const filteredPeople = addedItems.filter(
          (item) => item.id !== idToRemove
        );
        setAddedItems(filteredPeople);
      } else {
        setAddedItems([...addedItems, val]);
      }
      dispatch(testValue(val));
    }
  };

  const styleData = [
    {
      color: "#A67C0A",
      backgroundColor: "#FFFAED",
    },
    {
      color: "#7B0D06",
      backgroundColor: "#FFF1F0",
    },
    {
      color: "#004307",
      backgroundColor: "#FFFAED",
    },
    {
      color: "#A67C0A",
      backgroundColor: "#FFFAED",
    },
  ];

  React.useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/upload/admin/getTheTopDeals?type=populartests`
      )
      .then((resp) => {
        if (resp && resp.data && resp.data.propular_products) {
          setTopDeals(resp.data.propular_products);
        }
      })
      .catch((err) => console.log(err));

    axios
      .get(
        `${process.env.REACT_APP_API_URL}/upload/admin/getTheTopDeals?type=biochecks`
      )
      .then((res) => {
        if (res && res.data && res.data.biochecks_products) {
          setBioCheck(res.data.biochecks_products);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (filterValue) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL
          }/labtest/diagnostic/filterLists?type=${filterValue}&value=&area=${arealocal && arealocal.area && arealocal.area.value
          }&filter=A-Z&skip=0&limit=8`
        )
        .then((res) => setFilterData(res.data.data))
        .catch((err) => console.log(err));
    }
  }, [filterValue, arealocal]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/metadata/partner/getpartner`)
      .then((res) => {
        setPartner(res.data);
      })
      .catch((err) => console.log(err.resp));
  }, []);

  const setResponsiveness = () => {
    return window.innerWidth < 600 ? setMobileView(true) : setMobileView(false);
  };

  useEffect(() => {
    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());
    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);
  const handleItemDelete = (v) => {
    setShowSelected(true);
    dispatch(removeTest(v.doc.uuid));
  };

  const handlleRemoveTest = (v) => {
    dispatch(featureRemoveTest(v.uuid));
  };
  const onFind = () => {
    history.push("/populartest");
  };

  const FloatingIcon = (props) => {
    return (
      <div className="floatingIcon" onClick={() => props.onClick()}>
        <div className="count">{props.count}</div>
        <img alt="" src={ficon} />
        {(props.count === 0 && <div className="foverlay"></div>) || ""}
      </div>
    );
  };

  const phoneNumber = "+2349010996000";
  const boldStyle = {
    // fontWeight: 'bold',
    color: "#ff5c3c",
    cursor: "grab",
    fontWeight: "bold"
  };

  const handleWhatsAppClick = (event) => {
    console.log(event, "click on the whatsapp num")
    const formattedPhoneNumber = phoneNumber.replace(/\D/g, ''); // Remove any non-numeric characters
    const whatsappLink = `https://api.whatsapp.com/send?phone=${formattedPhoneNumber}`;
    window.open(whatsappLink, '_blank');
  };

  return (
    <Layout>
      <Helmet>
        <title>Shop Diagnostics Tests Online | Get Best Deals
        </title>
        <meta
          name='description'
          content='Shop from a wide range of tests with Diagnostic Marketplace, get your samples collected in the comfort of your home and receive downloadable results online.'
        />
      </Helmet>
      <div className="parentall">
        {mobileView === true ? (
          <div className="heroContainer">
            <div className="headhero">
              Experience convenient and affordable access to a wide range of medical tests
              {/* Convenient and <br />
              affordable access
              <br />
              to medical tests */}
            </div>
            {/* <div className="borderLines"></div> */}
            <div className="herobody">
              <div className="heropara">
                Browse through an extensive selection of tests, have your samples collected in the convenience of your own home, and receive easily accessible downloadable results online
              </div>
              <div className="iconSection">
                <div className="iconscard">
                  <img
                    // src={require("../../assets/images/mobIcon.svg").default}
                    src={Easy}
                    className="imgIcons"
                    alt=""
                  />
                  Discover Tests with Ease
                </div>
                <div className="iconscard">
                  <img
                    src={require("../../assets/images/family.svg").default}
                    // src={Compare}
                    className="imgIcons"
                    alt=""
                  />
                  Compare Prices
                </div>
                <div className="iconscard">
                  <img
                    // src={require("../../assets/images/wallet.svg").default}
                    src={Wall}
                    className="imgIcons"
                    alt=""
                  />
                  Save Big
                </div>
                <div className="iconscard">
                  <img
                    src={require("../../assets/images/homeMob.svg").default}
                    className="imgIcons"
                    alt=""
                  />
                  Access home <br /> service
                </div>
                <div className="iconscard">
                  <img
                    // src={require("../../assets/images/buyTest.svg").default}
                    src={Compare}
                    className="imgIcons"
                    alt=""
                  />
                  Compare
                  <br /> Prices
                </div>
                <div className="iconscard">
                  <img
                    src={require("../../assets/images/phone.svg").default}
                    className="imgIcons"
                    alt=""
                  />
                  Store test <br /> results
                </div>
              </div>
              <div className="mob-searchholder">
                {/* <div className="searchTextHold">
                  <input
                    type="text"
                    name="search"
                    value={landingSearch}
                    onChange={(e) => {
                      selandingSearch(e.target.value);
                    }}
                    placeholder="Search tests"
                    className="searchBox"
                    id=""
                  />
                  <img
                    src={require("../../assets/images/search.svg").default}
                    alt=""
                  />
                </div> */}
                <div className="searchFindbutton" onClick={() => onFind()}>
                  Find More Tests
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="parenttest1">
              <div className="parenttest">
                <div className="easiest">
                  Experience convenient and affordable access to a wide range of medical tests
                </div>
                {/* <img src={Yellowbar} alt="line" /> */}
                <div className="ensure">
                  Browse through an extensive selection of tests, have your samples collected in the convenience of your own home, and receive easily accessible downloadable results online
                </div>

                <div className="testcardparent">
                  <div className="testcardchild1">
                    <img src={Easy} alt="Torch" style={{ width: 45 }} />
                    <div className="torch">Discover Tests with Ease</div>
                  </div>

                  <div className="testcardchild2">
                    <img
                      // src={require("../../assets/images/buyTest.svg").default}
                      src={Compare}
                      style={{ width: 45 }}
                      alt="Torch"
                    />
                    <div className="torch">Compare Prices</div>
                  </div>

                  <div className="testcardchild3">
                    <img src={Wall} alt="Torch" style={{ width: 45 }} />
                    <div className="torch">Save Big</div>
                  </div>
                </div>

                <div
                  className="buyTestbuttn"
                  onClick={() => history.push("/populartest")}
                >
                  Shop Tests
                </div>
              </div>
              <div className="imagecontain">
                <img
                  style={{ backgroundColor: "transparent" }}
                  src={patientImage}
                  alt=""
                  className="inj"
                />
              </div>
            </div>
            <div className="longcardcontainer">
              <div className="longcardparent">
                <div className="longcard">
                  <img src={home} alt="" />
                  <div>Discover 6000+ Tests</div>
                  <span className="bor"></span>
                </div>

                <div className="longcard">
                  <img
                    src={require("../../assets/images/phone.svg").default}
                    style={{ width: 32 }}
                    alt=""
                  />
                  <div>35+ Top Lab Partners with Us</div>
                  <span className="bor"></span>
                </div>

                <div className="longcard">
                  <img
                    src={require("../../assets/images/family.svg").default}
                    style={{ width: 38 }}
                    alt=""
                  />
                  <div>Serving 41 Cities across 33 States</div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="img-cont-out">
          {mobileView ? (
            <div className="mobileCarddisplay" >
              <a
                href="#Patho_logy"
                onClick={() => {
                  setBtn(!btn);
                  setFilterValue("pathology");
                }}
              >
                <img
                  src={MobPath}
                  alt="icon"
                  style={{ width: "100%" }}
                />
              </a>
              <a
                href="#radio_logy"
                onClick={() => {
                  setBtn(!btn);
                  setFilterValue("radiology");
                }}
              >
                <img
                  src={MobRadio}
                  alt="icon"
                  style={{ width: "100%", marginTop: 25 }}
                />
              </a>
            </div>
          ) : (
            <div className="yellowTop" style={{ marginTop: "2%", display: "flex", justifyContent: "center" }}>
              <div className="yellow">
                <a
                  onClick={() => { history.push("/populartest") }}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={width <= 767 ? mobblueimage : blueimage} alt="blueimage" />
                </a>
              </div>
            </div>
          )}
          {/* <SliderComponent2 /> */}
        </div>
        {topDeals && topDeals.length > 0 ? (
          <div>
            <div className="deals">Top deals of the week</div>
            <div className="CardSelectTestland">
              {topDeals
                ? topDeals.map((value, ind) => (
                  <CardSelectTest
                    val={value}
                    handleItems={handleItems}
                    id={ind}
                    key={ind}
                    heading={value.doc.standardisedtestname}
                    subHeading={value.doc.partnerstestname}
                    des={value.doc.populartestdescription}
                    handleItemDelete={handleItemDelete}
                    styleData={styleData}
                  />
                ))
                : ""}
            </div>
          </div>
        ) : null}

        {/* {!mobileView &&  */}
        <div
          className="categoryland"
          style={{ background: "#F7F8FB", paddingBottom: "20px" }}
        >
          <div className="top-wrapper">
            <div className="left-wrap">
              <div className="cathead">Diagnostic Categories</div>
              <div className="btn-wrap">
                <div
                  // className={`btn ${selectedButton === 'Button1' ? 'selectedButton' : ''}`}
                  // onClick={() => handleButtonSelect('Button1')}

                  //  className={btn ? "btn btnAction" : "btn btnNoAction"}
                  className={filterValue === "pathology" ? "btn btnAction" : "btn btnNoAction"}

                  onClick={() => {
                    setBtn(btn);
                    setFilterValue("pathology");
                  }}
                  id="Patho_logy"

                >
                  PATHOLOGY
                </div>
                <div
                  // className={btn ? "btn btnAction" : "btn btnNoAction"}
                  className={filterValue === "radiology" ? "btn btnAction" : "btn btnNoAction"}

                  onClick={() => {
                    setBtn(btn);
                    setFilterValue("radiology");
                  }}
                  id="radio_logy"
                >
                  RADIOLOGY
                </div>
              </div>
            </div>
            {!mobileView && selected_test && selected_test.length > 0 && (
              <div style={{ position: "relative" }}>
                <div
                  className="right-wrap"
                  onClick={() => {
                    setShowSelected(!showSelected);
                  }}
                >
                  <div className="left-cont">
                    <span>{selected_test ? selected_test.length : 0}</span>
                  </div>
                  <div className="right-cont">
                    <span>
                      You have&nbsp;{selected_test ? selected_test.length : 0}
                      &nbsp;{selected_test.length > 1 ? "Tests" : "Test"} selected
                    </span>
                  </div>
                </div>
                {showSelected ? (
                  <div className="item-list-container">
                    <div className="header-font" style={{ paddingTop: "0px" }}>
                      Selected Tests
                    </div>
                    {selected_test.map((val, ind) => {
                      return (
                        <div className="inner-cont-out">
                          <div className="inner-cont">
                            <div className="left-content">
                              {val && val.standardisedtestname !== undefined
                                ? val.standardisedtestname
                                : val &&
                                  val.doc &&
                                  val.doc.standardisedtestname !== undefined
                                  ? val.doc.standardisedtestname
                                  : val.doc.paneltestname}
                            </div>
                            {console.log(val.doc.standardisedtestname, "fhvbfkjvfdkvhdfkjvhjfdhj")}
                            {val && val.standardisedtestname !== undefined ? (
                              <img
                                style={{ cursor: "pointer" }}
                                src={DelIcon}
                                alt="DelIcon"
                                onClick={() => handleItemDelete(val)}
                              />
                            ) : val &&
                              val.doc &&
                              val.doc.standardisedtestname !== undefined ? (
                              <img
                                style={{ cursor: "pointer" }}
                                src={DelIcon}
                                alt="DelIcon"
                                onClick={() => handleItemDelete(val)}
                              />
                            ) : (
                              <img
                                style={{ cursor: "pointer" }}
                                src={DelIcon}
                                alt="DelIcon"
                                onClick={() => handleItemDelete(val)}
                              />
                            )}
                          </div>
                        </div>
                      );
                    })}
                    <div className="compare-button-out">
                      <div
                        style={{ cursor: "pointer" }}
                        className="compare-button"
                        onClick={() => history.push("/populartest")}
                      >
                        <span>Select More Tests</span>
                      </div>
                      <div
                        style={{ cursor: "pointer" }}
                        className="compare-price-button"
                        onClick={() => {
                          history.push({
                            pathname: "/compareprice",
                            state: landData,
                          });
                        }}
                      >
                        <span>Compare Test Prices</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            )}

            <div>
              {mobileView && (
                <FloatingIcon
                  onClick={() => {
                    setShowSelected(!showSelected);
                  }}
                  count={selected_test ? selected_test.length : 0}
                />
              )}

              {mobileView && (
                <Sheet
                  isOpen={showSelected}
                  onClose={() => setShowSelected(false)}
                >
                  <Sheet.Container>
                    <Sheet.Header />
                    <Sheet.Content>
                      <MobileCardSelectedTest
                        type="landing"
                        onClose={() => {
                          setShowSelected(false);
                        }}
                        list={selected_test}
                        del={handleItemDelete}
                        featuredel={handlleRemoveTest}
                        area={arealocal}
                      />
                    </Sheet.Content>
                  </Sheet.Container>

                  <Sheet.Backdrop />
                </Sheet>
              )}
            </div>
          </div>
          <div className="CardSelectTestland22" >
            {console.log(filterData, "filterData")}
            {filterData && filterData.length !== 0
              ? filterData.map((value, index) => (
                <CardSelectTest
                  handleItems={handleItems}
                  type="diagnostic_categories"
                  key={index}
                  val={value}
                  id={value._id}
                  duplicate={true}
                  foot={false}
                  heading={value.doc.standardisedtestname}
                  subHeading={value.doc.partnerstestname}
                  des={value.doc.populartestdescription}
                  handleItemDelete={handleItemDelete}
                />
              ))
              : ""}
          </div>
          <div
            className="view-btn-cls"
            // onClick={() => history.push("/populartest", addedItems, filterValue)}
            onClick={() => history.push({ pathname: "/populartest", state: filterValue })}

          >
            <span>View More</span>
          </div>
        </div>

        {/* || ""} */}

        {mobileView ? (
          <div className="mobileCarddisplay">
            <a
              href="#Patho_logy"
              onClick={() => {
                setBtn(!btn);
                setFilterValue("pathology");
              }}
            >
              <img
                src={MobPath}
                alt="icon"
                style={{ width: "100%", marginTop: 25 }}
              />
            </a>
            <a
              href="#radio_logy"
              onClick={() => {
                setBtn(!btn);
                setFilterValue("radiology");
              }}
            >
              <img
                src={MobRadio}
                alt="icon"
                style={{ width: "100%", marginTop: 25 }}
              />
            </a>
          </div>
        ) : (
          <div className="yellowTop" style={{ display: "flex", justifyContent: "center", marginTop: "30px" }}>
            <div className="yellow">
              <a
                href={`${process.env.REACT_APP_SITE_URL
                  }/${"dashboardData"}/${getLoginDetails()}`}
                target="_blank"
                rel="noreferrer"
              >
                <img src={yellowcard} alt="icon" />
              </a>
            </div>
          </div>
        )}

        {(!mobileView && (
          <div className="CardSelectTestland2parpo">
            {bioCheck ? (
              <div className="deals">Popular BioCheck Tests</div>
            ) : null}
            <div className="CardSelectTestland2">
              {bioCheck
                ? bioCheck.map((value, ind) => (
                  <BioCheck
                    handleItems={handleItems}
                    key={ind}
                    val={value}
                    id={value._id}
                    heading={value.doc.paneltestname}
                    des={value.doc.description}
                    handleItemDelete={handleItemDelete}
                    bio={true}
                  />
                ))
                : ""}
            </div>

            {/* <div
              className="view"
              onClick={() =>
                history.push({
                  pathname: "/populartest",
                  state: landData,
                })
              }
            >
              <p>View More</p>
            </div> */}
          </div>
        )) ||
          ""}

        {/* Popular Health Checkup Packages */}

        {/* <div className="title">Popular Health Checkup Packages</div>
        <div className="CardSelectTestland" style={{ paddingBottom: "40px" }}>
          <LabPackage />
        </div>
        <div className="categoryland">
          <div
            className="view-btn-cls"
            onClick={() => history.push("/popularpackages", addedItems)}
          >
            <span>View More</span>
          </div>
        </div> */}

        <div style={{ background: "white" }}>
          <Questions />
          <SliderComponent />
        </div>

        {(!mobileView && (
          <div className="trustpar">
            <div className="by">OUR PARTNERS</div>
            {/* Need to style the images, */}
            <PartnerSlider partner={partner} />

            {/* <div className="imgc">
            {partner && partner.length !== 0
              ? partner.map((item, index) =>
                item.name === "SYNLAB" ? (
                  <div>
                    <img src={logos4} alt="icon" />
                  </div>
                ) : item.name === "ECHOLAB" ? (
                  <div>
                    <img src={logos1} alt="icon" />
                  </div>
                ) : item.name === "UNION DIAGNOSTICS" ? (
                  <div>
                    <img src={logos2} alt="icon" />
                  </div>
                ) : item.name === "IMAGE DIAGNOSTICS" ? (
                  <div>
                    <img src={logos3} alt="icon3" />
                  </div>
                ) : item.name === "DNA LABS" ? (
                  <img src={Dnabrand} alt="icon4" />
                ) : item.name === "CLINIX" ? (
                  <img src={logos3} alt="icon5" />
                ) : item.name === "CLINA LANCET" ? (
                  <img src={logos2} alt="icon6" />
                ) : item.name === "AFRIGLOBAL" ? (
                  <div>
                    <img src={logos5} alt="icon" />
                  </div>
                ) : item.name === "DOCTALL" ? (
                  <img src={doctall} alt="icon" />
                ) : (
                  <img src={doctall} alt="icon" />
                )
              )
              : ""}
          </div> */}
          </div>
        )) ||
          ""}
      </div>

      <button className="fixedButton" onClick={handleButtonClick}>

        <svg xmlns="http://www.w3.org/2000/svg" height="2em" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16" id="IconChangeColor"> <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" id="mainIconPathAttribute" fill="#ffffff"></path> </svg>
      </button>

      {/* Popup */}
      {showPopup && (
        <div className="popup">
          <p>We're here to assist you! If you have any difficulties finding tests, locating a lab, or have any questions, feel free to reach out to us on WhatsApp at{''} <span onClick={handleWhatsAppClick} className="phoneNumberBold"
            style={boldStyle}

          >{phoneNumber}</span>. Our team is ready to help you find the right diagnostic solutions and ensure a smooth experience.</p>
          <button className="popupButton" onClick={closePopup}>Close</button>
        </div>
      )}

      <Modal
        backdrop="static"
        keyboard={false}
        show={alertlocationPOP}
        onHide={handlealertPopupClose}
      >
        <div className="parentContainer">
          {/* <div className="popuphead5">Please select your location, before selecting the Test</div> */}
          <div className="popuphead5">Please note that after setting the location, you will need to select the test again to proceed. <br />Click OK to set the location and select the test</div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }} className="compare-button-out">
            <div className="popup_btn" onClick={handlePopupOpen}>Ok</div>&nbsp;&nbsp;&nbsp;
            <div className="popup_btn" onClick={handlealertPopupClose}>Cancel</div>
          </div>
        </div>


      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        show={locationPOP}
        onHide={handlePopupClose}
      >
        <Popup
          city={cities}
          onHide={(event) => {
            showLocationPop(false);
          }}
          type="landingPage"
          addedItems={addedItems}
        />
      </Modal>
    </Layout>
  );
}

export default BuyTest;
